import React from 'react';
import Link from '../../../shared/components/Link';
import style from './ProviderCardHeader.scss';

export default function ProviderCardHeader({ provider, providerUrl, providerSpecialty }) {
  return (
    <div className={style['provider-card-header']}>
      <figure className={style['provider-card-header__image']}>
        <Link to={providerUrl}>
          <img
            src={provider.profile.photo}
            srcSet={provider.profile.photo2x && `${provider.profile.photo2x} 2x`}
            alt={provider.display}
          />
        </Link>
      </figure>
      <div className={style['provider-card-header__content']}>
        <h4 className="font-size-md line-height-solid font-family-meta-bold text-ellipsis margin-none">
          <Link to={providerUrl}>{provider.display}</Link>
        </h4>
        {providerSpecialty && <p className="font-size-xs text-ellipsis">{providerSpecialty}</p>}
      </div>
    </div>
  );
}
